import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import * as z from 'zod'
import {DetailSectionSchema} from '../components/detailSection'

import {AssetItemSchema} from '../components/assetItem'
import {IconItemSchema} from '../components/iconItem'
import {IconLinkItemSchema} from '../components/iconLinkItem'
import {ImageLinkItemSchema} from '../components/imageLinkItem'
import {LinkSchema} from '../components/link'
import {MediaSchema} from '../components/media'
import {OverviewTemplateSettingsSchema} from '../components/overviewTemplateSettings'
import {SubnavSchema} from '../components/subnav'
import {TextItemSchema} from '../components/textItem'
import {IntroContextEnum} from './templateFlexSuiteOverview'

export const DetailsHeroVariantEnum = z.enum(['Stacked', 'Carousel', 'Default', '50/50'])

export type DetailsHeroVariant = z.infer<typeof DetailsHeroVariantEnum>

export const IntroLogoTypeEnum = z.enum(['Marquee', 'Tiles'])

export type IntroLogoType = z.infer<typeof IntroLogoTypeEnum>

export const TemplateFlexSuiteDetailsSchema = buildEntrySchemaFor('templateFlexSuiteDetails', {
  fields: z.lazy(() =>
    z.object({
      title: z.string().optional(),
      featuredSections: safeOptional(z.array(DetailSectionSchema)),
      // Template Settings (e.g. branded experience)
      settings: safeOptional(OverviewTemplateSettingsSchema),
      // SubNav
      subNav: safeOptional(SubnavSchema),
      // Hero
      heroHeading: RichTextSchema,
      heroLabel: z.string().optional(),
      heroDescription: safeOptional(RichTextSchema),
      heroCtaOne: LinkSchema,
      heroCtaTwo: safeOptional(LinkSchema),
      heroTertiaryDescription: safeOptional(RichTextSchema),
      heroVariant: safeOptional(DetailsHeroVariantEnum),
      heroAsset: safeOptional(MediaSchema),
      heroCarousel: safeOptional(z.array(AssetItemSchema)),
      // Intro
      introLogoHeading: z.string().optional(),
      introLogoType: safeOptional(IntroLogoTypeEnum),
      introLogos: safeOptional(z.array(z.string())),
      introLogoLink: safeOptional(LinkSchema),
      introContext: safeOptional(IntroContextEnum),
      introContextHeading: safeOptional(RichTextSchema),
      introContextLink: safeOptional(LinkSchema),
      introContextBody: safeOptional(RichTextSchema),
      introItems: safeOptional(z.array(z.union([IconLinkItemSchema, TextItemSchema]))),
      introIconCards: safeOptional(z.array(IconLinkItemSchema)),
      introPillars: safeOptional(z.array(IconItemSchema)),
      introImageCards: safeOptional(z.array(ImageLinkItemSchema)),
      introStats: safeOptional(z.array(TextItemSchema)),
    }),
  ),
})

export type TemplateFlexSuiteDetails = z.infer<typeof TemplateFlexSuiteDetailsSchema>
